import { object, SchemaOf, string } from "yup";
import { requiredFieldValidationMessage } from "../../../Forms/ValidationMessages";
import { TTProtection } from "../TTProtection";

export const ttProtectionSchema: SchemaOf<TTProtection> = object()
  .shape({
    Name: string().required(requiredFieldValidationMessage("Name")).default(""),
  })
  .required();
